module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_018.png
// module id = 2334
// module chunks = 5